import { useEffect,useState } from "react";
import "./style.css";

const PaginationComponent = ({ data, itemsPerPage, onPageChange, totalRows, currentPage }) => {
  const [pageNumbers, setPageNumbers] = useState([]);

  const isActive = (page) => {
    return (page == currentPage) ? 'active-page' : ''
  }
  useEffect(() => {
    const pagesArray = [];
    const totalPages = Math.ceil(totalRows/itemsPerPage)
    let minPage = currentPage-4
    if(currentPage < 5){
      minPage = 1
    }
    let maxPage = minPage + 8
    if(maxPage > totalRows){
      maxPage = totalRows
    }
    for (let i = minPage; i <= maxPage; i++) {
      if(maxPage-i == 0){
        pagesArray.push(totalPages)
        break
      }
      pagesArray.push(i);
    }
    setPageNumbers(pagesArray)
  }, [data]);

  // Function to handle click on page number
  const handlePageClick = (pageNumber) => {
    onPageChange(pageNumber);
  };

  // Render the pagination controls
  return (
    <div className="pagination-container">
      {pageNumbers.map(number => (
        <button
          key={number}
          onClick={() => handlePageClick(number)}
          className={`page-item ${isActive(number)}`}
        >
          {number}
        </button>
      ))}
    </div>
  );
};

export default PaginationComponent
